import { render, staticRenderFns } from "./MatchStaffList.vue?vue&type=template&id=4affb4b6&"
import script from "./MatchStaffList.vue?vue&type=script&lang=js&"
export * from "./MatchStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports